import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { UserType } from '../App';

interface UserState {
  user: UserType | null;
  accessToken: string | null;
  refreshToken: string | null;
  setUser: (user: UserState['user']) => void;
  setTokens: (tokens: { accessToken: string | null; refreshToken: string | null }) => void;
  clearUser: () => void;
  clearTokens: () => void;
  updateUser: (partialUser: Partial<NonNullable<UserState['user']>>) => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      setUser: (user) => set({ user }),
      setTokens: ({ accessToken, refreshToken }) => set({ accessToken, refreshToken }),
      clearUser: () => set({ user: null, accessToken: null, refreshToken: null }),
      clearTokens: () => set({ accessToken: null, refreshToken: null }),
      updateUser: (partialUser) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...partialUser } : null,
        })),
    }),
    {
      name: 'user-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
